import { AppProvider, DrawerProvider, PageTitleProvider, RadiationNotifsProvider } from './core/contexts';
import { MuiThemeProvider } from '@material-ui/core';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { theme } from './core/utils';
import { routes } from './core/models';
import { Layout } from './components';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import frLocale from 'date-fns/locale/fr';
import enLocale from 'date-fns/locale/en-US';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import { RedirectHandler } from 'components/RedirectHandler/RedirectHandler';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { useState } from 'react';
import store from '../src/core/stores/store';
import { Provider } from 'react-redux';
import { NotificationProvider } from './features/notification/contexts/NotificationProvider';

const localeMap = {
    en: enLocale,
    fr: frLocale,
};

function App() {
    const { t, i18n } = useTranslation();

    Yup.setLocale({
        mixed: {
            required: t('yup.validators.required'),
            notType: (ref) => {
                switch (ref.type) {
                    case 'number':
                        return t('yup.validators.invalidNumber');
                    case 'date':
                        return t('yup.validators.invalidDate');
                    default:
                        return t('yup.validators.invalidValue');
                }
            },
        },
        number: {
            min: ({ min }) => t('yup.validators.number.min', { min }),
            max: ({ max }) => t('yup.validators.number.max', { max }),
        },
        string: {
            length: ({ length }) => t('yup.validators.string.length', { length }),
            min: ({ min }) => t('yup.validators.string.min', { min }),
            max: ({ max }) => t('yup.validators.string.max', { max }),
        },
        date: {
            min: ({ min }) => t('yup.validators.date.min', { min }),
            max: ({ max }) => t('yup.validators.date.max', { max }),
        },
    });
    const [queryClient] = useState(() => new QueryClient());

    return (
        <Provider store={store}>
            <AppProvider>
                <QueryClientProvider client={queryClient}>
                    <DrawerProvider>
                        <MuiThemeProvider theme={theme}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap[i18n.language]}>
                                <Router>
                                    <RedirectHandler>
                                        <PageTitleProvider>
                                            <NotificationProvider>
                                                <RadiationNotifsProvider>
                                                    <Layout>
                                                        <Switch>
                                                            {routes.map((r) => (
                                                                <Route key={r.name} exact path={r.path} component={r.component} />
                                                            ))}
                                                        </Switch>
                                                    </Layout>
                                                </RadiationNotifsProvider>
                                            </NotificationProvider>
                                        </PageTitleProvider>
                                    </RedirectHandler>
                                </Router>
                            </MuiPickersUtilsProvider>
                        </MuiThemeProvider>
                    </DrawerProvider>
                    <ReactQueryDevtools initialIsOpen={false} />
                </QueryClientProvider>
            </AppProvider>
        </Provider>
    );
}

export default App;
